import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 学生列表
 * @param params
 * 
*/

export const studentList = params => Http.get(`${baseUrl}/class/user`, { params })

/**
 * 删除学生
 * @param classUserId
 * 
*/

export const delTeam = classUserId => Http.delete(`${baseUrl}/class/user/${classUserId}` )

/**
 * 导入学员
 * @param params
 * 
*/

export const importStudent = params => Http.post(`${baseUrl}/class/import`,  params )

/**
 * 模板导入学员
 * @param params
 * 
*/

export const importMember = params => Http.post(`${baseUrl}/class/${params.classId}/import`,  params.file )

/**
 * 重置密码
 * @param params
 * 
*/

export const resetMemberPass = params => Http.put(`${baseUrl}/class/user/restPassword`,  params )
